// extracted by css-extract-rspack-plugin
module.exports =  {"avatar":"RateProDialogViewModel__avatar___h9AdG"};